import styled from "styled-components";

export const FooterFirstSection = styled.div`
  max-width: 96rem;
  margin: 0 auto;
  color: white;
  overflow: hidden;

  .first__line {
    box-sizing: border-box;
    padding: 2.5rem 0.75rem 2.5rem 0.75rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .first__line__links {
      display: flex;
      align-items: center;
      gap: 6.25rem;
    }

    @media(max-width:998px){
        flex-direction: column;

        & div:first-child{
          margin-bottom: 1.875rem;
        }
    }

     @media(max-width:768px){
      .first__line__links{
        flex-direction: column;
        gap: 2.25rem;
      }
    }
  }

  .second__line {
    box-sizing: border-box;

    .second__line__container {
      padding-top: 3.75rem;
      padding-bottom: 3.75rem;
      border-top: 1px solid hsla(0, 0%, 100%, 0.1);

      .second__line__info {
        div {
          padding-left: 0.75rem;
          padding-right: 0.75rem;
          flex: 0 0 auto;
          width: 100%;
        }

        ul {
          border-bottom: 1px solid hsla(0, 0%, 100%, 0.1);
          padding-bottom: 1.875rem;

          li {
            flex: 0 0 auto;
            width: 25%;
            text-align: center;
          }

          li:last-child {
            text-align: right;
          }

          li:first-child {
            text-align: left;
          }

          .first__li {
            font-weight: 700;
            text-transform: uppercase;
          }

          .second__li {
            font-weight: 300;
          }
        }
      }
    }

    @media(max-width:768px){
      .second__line__container{
        padding-top: 1.75rem;
        padding-bottom: 1.75rem;
      }
        .second__line__info {
          ul{
              li{
                flex: auto;
                width: 100% !important;  
              }
              li:last-child {
                text-align: center !important;
              }

              li:first-child {
                text-align: center !important;
              }
          }
            }
    }
  }

  .row {
    display: flex;
    row-gap: 1.875rem;
    flex-wrap: wrap;
    @media(max-width:768px){
      row-gap: 0.875rem;
    }
  }
`;

export const FooterSecondSection = styled.div`
  background-color: #010737;
  box-sizing: border-box;
  color: white;

  .second__section__container {
    max-width: 96rem;
    margin: 0 auto;
    padding-left: 0.75rem;
    padding-right: 0.75rem;

    .first__text {
      padding-top: 2.5rem;
      padding-bottom: 2.5rem;
      font-size: 0.875rem;

      p {
        margin-bottom: 1rem;
      }
    }

    .second__text {
      border-top: 1px solid hsla(0, 0%, 100%, 0.1);
      padding-top: 1.875rem;
      padding-bottom: 2.5rem;
      font-size: 0.75rem;
      color: hsla(0, 0%, 100%, 0.6);
    }
  }
`;
